import React, { FC } from 'react';
import { STATIC_MEDIA_DOMAIN } from '@src/constants';
import { Image } from '@src/components/Image';
import './styles.scss';

export const FeedEmptyState: FC = () => {
  return (
    <div className="opening-empty-state">
      <div className="opening-empty-state__container">
        <Image className="opening-empty-state__image" src={`${STATIC_MEDIA_DOMAIN}/images/ta-empty-state.png`} />
        <h3>Waiting for new candidates...</h3>
        <p className="opening-empty-state__text">
          Check back soon to review new people available to <br />
          invite to your position. We'll also notify you via email.
        </p>
      </div>
    </div>
  );
};
